// extracted by mini-css-extract-plugin
export default {"userInfo":"editFrom_userInfo__Nmas4","data":"editFrom_data__k9PJS","saveBtn":"editFrom_saveBtn__w2d1A"};